import $ from 'jquery';
import { AJAX_URL } from './config';

$(() => {
  // Check for add to cart class
  if ($('.show--menu')[0]) {
    setTimeout(function () {
      $('.educational-resources--my-cart-container').addClass('hover');
    }, 750);

    setTimeout(function () {
      $('.educational-resources--my-cart-container').removeClass('hover');
      $('.sub-menu__cart').removeClass('show--menu sub-menu__cart-added');
    }, 5000);
  }

  $('html').on('click', 'button.plus, button.minus', function () {
    // Get current quantity values
    const qty = $(this).parent().find('.qty');
    const val = parseFloat(qty.val());
    const max = parseFloat(qty.attr('max'));
    const min = parseFloat(qty.attr('min'));
    const step = parseFloat(qty.attr('step'));

    // Change the value if plus or minus
    if ($(this).is('.plus')) {
      if (max && max <= val) {
        qty.val(max);
        qty.trigger('change');
      } else {
        qty.val(val + step);
        qty.trigger('change');
      }
    } else {
      if (min && min >= val) {
        qty.val(min);
      } else if (val > 1) {
        qty.val(val - step);
        qty.trigger('change');
      }
    }
  });

  $('.woocommerce').on('change', 'input.qty', function () {
    $("[name='update_cart']").prop('disabled', false);
    $('.checkout-button').addClass('btn--disabled');
    $('.cart-notice').removeClass('u--display-none');
  });

  $('.woocommerce-cart-header_type-toggle').on('click', 'button', (event) => {
    $.ajax({
      url: `${AJAX_URL}toggle_emailing_coupon`,
      type: 'POST',
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data }) => {
        location.reload();
      })
      .catch((err) => console.log(err.message));
  });

  $("input[name='single-items']").change(function () {
    if (
      $(this).prop('checked') === true &&
      $("[name='update_cart']").is(':disabled')
    ) {
      $('.checkout-button').removeClass('btn--disabled');
    } else {
      $('.checkout-button').addClass('btn--disabled');
    }
  });

  $('html').on('click', '.wc--add-to-cart', (event) => {
    const product_id = event.currentTarget.getAttribute('data-product-id');
    const quantity = 1;
    const button = event.currentTarget;

    $.ajax({
      url: `${AJAX_URL}post_add_products_to_cart`,
      data: { product_id, quantity },
      type: 'POST',
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data }) => {
        const subMenuContainer = $('.educational-resources--my-cart-container');

        $('.sub-menu__cart-list').html(data.submenu_html);
        $('.sub-menu__cart').removeClass('u--display-none');

        setTimeout(function () {
          button.classList.add('btn--green');
          button.innerText = 'Added To Order';
          subMenuContainer.addClass('hover');
          $('.sub-menu__cart').addClass('sub-menu__cart-added');
        }, 750);

        setTimeout(function () {
          button.classList.remove('btn--green');
          button.innerText = 'Add To Order';
          subMenuContainer.removeClass('hover');
          $('.sub-menu__cart').removeClass('sub-menu__cart-added');
        }, 5000);
      })
      .catch((err) => console.log(err.message));
  });

  $('.cart-quantity-button.toolkit-qty-btn.plus').on('click', function () {
    var input = $(this).siblings('input[type="number"]');
    changeQuantity(input, 1);
  });

  $('.cart-quantity-button.toolkit-qty-btn.minus').on('click', function () {
    var input = $(this).siblings('input[type="number"]');
    changeQuantity(input, -1);
  });

  function changeQuantity(input, change) {
    var currentValue = parseInt(input.val());
    var newValue = currentValue + change;

    if (
      newValue >= parseInt(input.attr('min')) &&
      newValue <= parseInt(input.attr('max'))
    ) {
      input.val(newValue);
    }
  }

  $('#wl-edit-toolkit-qty').on('click', function (e) {
    e.preventDefault();
    $('.tool-kit-quantity .cart-quantity-button').css('display', function (index, value) {
      return value === 'none' ? 'inline-block' : 'none';
    });

    var inputsDisabled = $('.tool-kit-quantity input').prop('disabled');
    $('.tool-kit-quantity input').prop('disabled', !inputsDisabled);

    if (inputsDisabled) {
      $('#wl-edit-toolkit-qty').text('Finished Editing');
    } else {
      $('#wl-edit-toolkit-qty').text('Edit Quantities');
    }
  });
});
